import React, { useEffect, useState } from 'react';
import '../css/common.css';
import '../css/button.css';
import { Navigate, useNavigate } from 'react-router-dom';

const Nav = (props) => {

    const langue = props.langue;
    let allera = ""
    if (langue == "fr") {
        allera = "aller à..."
    } else if (langue == "en") {
        allera = "go to..."
    } else if (langue == "es") {
        allera = "ir a..."
    } else if (langue == "de") {
        allera = "gehen Sie zu..."
    } else if (langue == "oc") {
        allera = "anar a..."
    }

    let chapPrec = ""
    if (langue == "fr") {
        chapPrec = "chapitre précédent"
    } else if (langue == "en") {
        chapPrec = "previous chapter"
    } else if (langue == "es") {
        chapPrec = "capítulo anterior"
    } else if (langue == "de") {
        chapPrec = "vorheriges Kapitel"
    } else if (langue == "oc") {
        chapPrec = "capítol precedent"
    }

    let chapSuiv = ""
    if (langue == "fr") {
        chapSuiv = "chapitre suivant"
    } else if (langue == "en") {
        chapSuiv = "next chapter"
    } else if (langue == "es") {
        chapSuiv = "siguiente capítulo"
    } else if (langue == "de") {
        chapSuiv = "nächstes Kapitel"
    } else if (langue == "oc") {
        chapSuiv = "capítol seguent"
    }

    const [currentPage, setCurrentPage] = useState("x");

    const navigate = useNavigate();

    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const [precHovered, setPrecHovered] = useState(false);
    const [suivHovered, setSuivHovered] = useState(false);

    const listOfPreviousPages = {
        "0.1": "/start/",
        "0.2": "/start/",
        "1": "/menudida/",
        "2": "/module/1-intro/",
        "3.1": "/module/2-captation/",
        "3.2": "/module/3-imitation-1/",
        "3.3": "/module/3-imitation-2-markov/",
        "3.4": "/module/3-imitation-3-donnalee/",
        "3.5": "/module/3-imitation-4-uzeste/",
        "3.6": "/module/3-imitation-5-walking/",
        "4.1": "/module/3-imitation-5-motifs/",
        "4.2": "/module/4-transformationA-1/",
        "4.3": "/module/4-transformationA-2-patch/",
        "5.1": "/module/4-transformationA-3-arpeges/",
        "5.2": "/module/5-transformationB-1/",
        "5.3": "/module/5-transformationB-2-hothouse/",
        "5.4": "/module/5-transformationB-3-godel/",
        "5.5": "/module/5-transformationB-4-reecritures/",
        "5.6": "/module/5-transformationB-5-subtitutions/",
        "6.1": "/module/5-transformationB-5-goodbye/",
        "6.2": "/module/6-controle-1/",
        "6.3": "/module/6-controle-2-lubatyscaphe/",
        "6.4": "/module/6-controle-3-memoire/",
    };

    const listOfNextPages = {
        "0.1": "/module/1-intro/",
        "0.2": "/module/1-intro/",
        "1": "/module/2-captation/",
        "2": "/module/3-imitation-1/",
        "3.1": "/module/3-imitation-2-markov/",
        "3.2": "/module/3-imitation-3-donnalee/",
        "3.3": "/module/3-imitation-4-uzeste/",
        "3.4": "/module/3-imitation-5-walking/",
        "3.5": "/module/3-imitation-5-motifs/",
        "3.6": "/module/4-transformationA-1/",
        "4.1": "/module/4-transformationA-2-patch/",
        "4.2": "/module/4-transformationA-3-arpeges/",
        "4.3": "/module/5-transformationB-1/",
        "5.1": "/module/5-transformationB-2-hothouse/",
        "5.2": "/module/5-transformationB-3-godel/",
        "5.3": "/module/5-transformationB-4-reecritures/",
        "5.4": "/module/5-transformationB-5-subtitutions/",
        "5.5": "/module/5-transformationB-5-goodbye/",
        "5.6": "/module/6-controle-1/",
        "6.1": "/module/6-controle-2-lubatyscaphe/",
        "6.2": "/module/6-controle-3-memoire/",
        "6.3": "/start",
    };

    const nomPage = [
        ["0", "/start", "ACCUEIL", "#607e8c"],
        ["0.1", "/menudida/", "DIDACTIQUE", "#607e8c"],
        ["0.2", "/menumusic/", "MUSICAL", "#607e8c"],
        ["1", "/module/1-intro/", "introduction", "#607e8c"],
        ["2", "/module/2-captation/", "captation", "#607e8c"],
        ["3.1", "/module/3-imitation-1/", "imitation 1", "#607e8c"],
        ["3.2", "/module/3-imitation-2-markov/", "2 markov", "#17846e"],
        ["3.3", "/module/3-imitation-3-donnalee/", "3 donnalee", "#17846e"],
        ["3.4", "/module/3-imitation-4-uzeste/", "4 uzeste", "#17846e"],
        ["3.5", "/module/3-imitation-5-walking/", "5 walking", "#17846e"],
        ["3.6", "/module/3-imitation-5-motifs/", "6 motifs", "#17846e"],
        ["4.1", "/module/4-transformationA-1/", "transformation A 1", "#607e8c"],
        ["4.2", "/module/4-transformationA-2-patch/", "2 patch", "#17846e"],
        ["4.3", "/module/4-transformationA-3-arpeges/", "3 arpeges", "#17846e"],
        ["5.1", "/module/5-transformationB-1/", "transformation B 1", "#607e8c"],
        ["5.2", "/module/5-transformationB-2-hothouse/", "2 hothouse", "#17846e"],
        ["5.3", "/module/5-transformationB-3-godel/", "3 godel", "#17846e"],
        ["5.4", "/module/5-transformationB-4-reecritures/", "4 reecriture", "#17846e"],
        ["5.5", "/module/5-transformationB-5-subtitutions/", "5 substitutions", "#17846e"],
        ["5.6", "/module/5-transformationB-5-goodbye/", "6 goodbye", "#17846e"],
        ["6.1", "/module/6-controle-1/", "contrôle 1", "#607e8c"],
        ["6.2", "/module/6-controle-2-lubatyscaphe/", "2 lubatyscaphe", "#17846e"],
        ["6.3", "/module/6-controle-3-memoire/", "3 memoire", "#17846e"],
    ];

    function clearAll() {
        // Get a reference to the last interval + 1
        const interval_id = window.setInterval(function () { }, Number.MAX_SAFE_INTEGER);

        // Clear any timeout/interval up to that id
        for (let i = 1; i < interval_id; i++) {
            window.clearInterval(i);
        }

        props.audio.forEach(audio => audio.pause());
    }

    const menu = [];
    for (let i = 0; i < nomPage.length; i++) {
        menu.push(<div
            key={i}
            style={{
                backgroundColor: currentPage == nomPage[i][0] ? "#6fe2ca" : nomPage[i][3],
                width: currentPage == nomPage[i][0] ? "100%" : "90%",
                borderTopRightRadius: currentPage == nomPage[i][0] ? "10px" : "0px",
                borderBottomRightRadius: currentPage == nomPage[i][0] ? "10px" : "0px",
                fontFamily: "Verdana",
            }}
            onClick={
                () => {
                    clearAll();
                    navigate(process.env.PUBLIC_URL + nomPage[i][1]);
                }
            }
            onMouseEnter={
                (e) => {
                    e.target.parentNode.style.width = "100%";
                    e.target.parentNode.style.borderTopRightRadius = "10px";
                    e.target.parentNode.style.borderBottomRightRadius = "10px";
                }
            }
            onMouseLeave={
                (e) => {
                    e.target.parentNode.style.width = currentPage == nomPage[i][0] ? "100%" : "90%";
                    e.target.parentNode.style.borderTopRightRadius = currentPage == nomPage[i][0] ? "10px" : "0px";
                    e.target.parentNode.style.borderBottomRightRadius = currentPage == nomPage[i][0] ? "10px" : "0px";
                }
            }
        >
            <p className="numberLabel"
                style={{
                    color: "black",
                    margin: 0,
                    padding: 1,
                    fontSize: 10,
                    width: "100%",
                    userSelect: "none"
                }} >
                {nomPage[i][2]}
            </p>
        </div>
        );
    }


    useEffect(() => {
        switch (window.location.pathname) {
            case process.env.PUBLIC_URL + '/':
                setCurrentPage("x");
                break;
            case process.env.PUBLIC_URL + '/menudida/':
                setCurrentPage("0.1");
                break;
            case process.env.PUBLIC_URL + '/menumusic/':
                setCurrentPage("0.2");
                break;
            case process.env.PUBLIC_URL + '/module/1-intro/':
                setCurrentPage("1");
                break;
            case process.env.PUBLIC_URL + '/module/2-captation/':
                setCurrentPage("2");
                break;
            case process.env.PUBLIC_URL + '/module/3-imitation-1/':
                setCurrentPage("3.1");
                break;
            case process.env.PUBLIC_URL + '/module/3-imitation-2-markov/':
                setCurrentPage("3.2");
                break;
            case process.env.PUBLIC_URL + '/module/3-imitation-3-donnalee/':
                setCurrentPage("3.3");
                break;
            case process.env.PUBLIC_URL + '/module/3-imitation-4-uzeste/':
                setCurrentPage("3.4");
                break;
            case process.env.PUBLIC_URL + '/module/3-imitation-5-walking/':
                setCurrentPage("3.5");
                break;
            case process.env.PUBLIC_URL + '/module/3-imitation-5-motifs/':
                setCurrentPage("3.6");
                break;
            case process.env.PUBLIC_URL + '/module/4-transformationA-1/':
                setCurrentPage("4.1");
                break;
            case process.env.PUBLIC_URL + '/module/4-transformationA-2-patch/':
                setCurrentPage("4.2");
                break;
            case process.env.PUBLIC_URL + '/module/4-transformationA-3-arpeges/':
                setCurrentPage("4.3");
                break;
            case process.env.PUBLIC_URL + '/module/5-transformationB-1/':
                setCurrentPage("5.1");
                break;
            case process.env.PUBLIC_URL + '/module/5-transformationB-2-hothouse/':
                setCurrentPage("5.2");
                break;
            case process.env.PUBLIC_URL + '/module/5-transformationB-3-godel/':
                setCurrentPage("5.3");
                break;
            case process.env.PUBLIC_URL + '/module/5-transformationB-4-reecritures/':
                setCurrentPage("5.4");
                break;
            case process.env.PUBLIC_URL + '/module/5-transformationB-5-subtitutions/':
                setCurrentPage("5.5");
                break;
            case process.env.PUBLIC_URL + '/module/5-transformationB-5-goodbye/':
                setCurrentPage("5.6");
                break;
            case process.env.PUBLIC_URL + '/module/6-controle-1/':
                setCurrentPage("6.1");
                break;
            case process.env.PUBLIC_URL + '/module/6-controle-2-lubatyscaphe/':
                setCurrentPage("6.2");
                break;
            case process.env.PUBLIC_URL + '/module/6-controle-3-memoire/':
                setCurrentPage("6.3");
                break;
            default:
                setCurrentPage("0");
                break;
        }
    }, [window.location.pathname]);

    return (
        <div>
            {
                currentPage !== "x" && currentPage !== "0" &&
                <div
                    style={{
                        position: 'absolute',
                        top: '457px',
                        left: '420px',
                        zIndex: 17,
                    }}
                    id="nav"
                >
                    <div
                        onMouseLeave={() => {
                            setTimeout(() => {
                                setIsMenuOpen(false);
                            }, 100);
                        }}
                        style={{ cursor: 'pointer' }}
                    >
                        <div
                            className='inflateButtonTiny'
                            onMouseEnter={() => {
                                setIsMenuOpen(true);
                            }}

                        >
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/nav/4.png"}
                                style={{ position: 'absolute', top: '10px', left: '0px' }}
                            />
                            <p
                                style={{
                                    position: 'absolute',
                                    top: '0px',
                                    left: '40px',
                                    width: '100px',
                                    color: 'white',
                                    fontSize: '15px',
                                    userSelect: 'none',
                                }}
                            >
                                {allera}
                            </p>
                        </div>
                        <div
                            style={{
                                position: 'absolute',
                                top: '-385px',
                                left: '35px',
                                width: '120px',
                                zIndex: 18,
                                display: isMenuOpen ? 'block' : 'none',
                                transform: 'scale(1.27)',
                            }}
                            onMouseLeave={() => {
                                setTimeout(() => {
                                    setIsMenuOpen(false);
                                }, 100);
                            }}
                        >
                            {menu}
                        </div>
                    </div>
                    <div
                        style={{
                            cursor: 'pointer',
                        }}
                        onMouseEnter={() => {
                            setPrecHovered(true);
                        }}
                        onMouseLeave={() => {
                            setPrecHovered(false);
                        }}
                        onClick={
                            () => {
                                clearAll();
                                navigate(process.env.PUBLIC_URL + listOfPreviousPages[currentPage]);
                            }
                        }
                    >
                        <img
                            src={process.env.PUBLIC_URL + "/assets/images/nav/2.png"}
                            style={{ position: 'absolute', top: '-2px', left: '122px' }}
                            className='inflateButtonMore'
                        />
                        <p
                            style={{
                                position: 'absolute',
                                top: -5,
                                left: 113,
                                width: 30,
                                color: 'white',
                                fontSize: 10,
                                userSelect: 'none',
                                pointerEvents: 'none',
                                zIndex: 9,
                                display: precHovered ? 'block' : 'none',
                            }}
                        >
                            {chapPrec}
                        </p>
                    </div>
                    <div>
                        <p
                            style={{
                                position: 'absolute',
                                top: '0px',
                                left: '160px',
                                width: '20px',
                                color: 'white',
                                fontSize: '13px',
                                userSelect: 'none',
                                textAlign: 'center',
                                cursor: 'pointer',
                                zIndex: 9
                            }}
                            onClick={() => {
                                //recharge la page
                                clearAll();
                                //Get the elem 1 of the array that has elem 0 == current page
                                navigate(0);
                            }}
                        >
                            {currentPage == "0.1" || currentPage == "0.2" ? "" : currentPage}
                        </p>
                        <img
                            src={process.env.PUBLIC_URL + "/assets/images/nav/3.png"}
                            style={{ position: 'absolute', top: '8px', left: '156px' }}
                        />
                    </div>
                    <div
                        style={{
                            cursor: 'pointer',
                        }}
                        onMouseEnter={() => {
                            setSuivHovered(true);
                        }}
                        onMouseLeave={() => {
                            setSuivHovered(false);
                        }}
                        onClick={
                            () => {
                                clearAll();
                                navigate(process.env.PUBLIC_URL + listOfNextPages[currentPage]);
                            }
                        }
                    >
                        <img
                            src={process.env.PUBLIC_URL + "/assets/images/nav/1.png"}
                            style={{ position: 'absolute', top: '-2px', left: '175px' }}
                            className='inflateButtonMore'
                        />
                        <p
                            style={{
                                position: 'absolute',
                                top: -5,
                                left: 189,
                                width: 30,
                                color: 'white',
                                fontSize: 10,
                                userSelect: 'none',
                                pointerEvents: 'none',
                                zIndex: 9,
                                display: suivHovered ? 'block' : 'none',
                            }}
                        >
                            {chapSuiv}
                        </p>
                    </div>
                </div>
            }
        </div >
    );
}

export default Nav;
